import Slider from "rc-slider";

import FormLabel from "./form-label";

type RCRangeProps = {
  label: string;
  min: number;
  max: number;
  value: number[];
  step?: number;
  onChange: (value: number | number[]) => void;
};

export default function RCRange({ label, min, max, value, step = 1, onChange }: RCRangeProps) {
  return (
    <>
      <FormLabel label={label} />
      <div
        className="d-flex align-items-center"
        style={{ border: "1px solid #c8c8c8", padding: "0.375em 0.875em", borderRadius: "4px" }}
      >
        <div className="me-4 text-muted">{value[0]}</div>
        <div className="flex-grow-1">
          <Slider range min={min} max={max} value={value} step={step} onChange={onChange} />
        </div>
        <div className="ms-4 text-muted">{value[1]}</div>
      </div>
    </>
  );
}
